import {observer} from "mobx-react";
import {Component} from "preact";
import {tokenStore, updateModel} from "../model";
import {AlertDialog} from "./AlertDialog";
import style from "./AppShell.module.css";
import {KeyCardView} from "./KeyCardView";
import {PWA} from "./PWA";
import {SignUpView} from "./SignUpView";
import {UpdateDialog} from "./UpdateDialog";

export const AppShell = observer(
	class AppShell extends Component {
		render() {
			return (
				<div class={style.appShell}>
					<div class={style.appShellWrapper}>
						{tokenStore.token ? <KeyCardView /> : <SignUpView />}
						<AlertDialog />
						<UpdateDialog open={updateModel.pending} />
						<PWA />
					</div>
				</div>
			);
		}
	},
);
